"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useLayout } from "@/lib/context/layout";
import client from "@/lib/api/client";

export default function Home() {
    const router = useRouter();
    const { activeContext, enableDashboards } = useLayout();
    const [debug, setDebug] = useState<string[]>([]);

    const add = (s: string) => setDebug((d) => [...d, s]);

    useEffect(() => {
        add(`enableDashboards=${enableDashboards}`);
        if (enableDashboards) {
            const home = (activeContext.properties as Record<string, { value: string }>)?.home_page;
            const target = home?.value || "/dashboard";
            add(`redirecting to ${target}`);
            router.replace(target);
        }
    }, [activeContext, enableDashboards]);

    useEffect(() => {
        add(`token=${client.token ? "yes" : "no"}`);
        add("calling get_contexts directly...");
        client.get_contexts().then((ctx) => {
            add(`get_contexts returned: ${JSON.stringify(ctx).slice(0, 200)}`);
        }).catch((err) => {
            add(`get_contexts error: ${err}`);
        });
    }, []);

    return (
        <div className="space-y-4 p-8">
            <h1 className="text-lg font-bold">Portal Debug</h1>
            <div className="space-y-1 text-sm text-muted-foreground font-mono">
                {debug.map((line, i) => (
                    <div key={i}>{line}</div>
                ))}
            </div>
        </div>
    );
}
